import SocialButton, { SocialPlatform } from 'components/common/SocialButton';
import { CommunityUserProfile } from 'types/community';
import styles from './ProfileSocialLinks.module.css';

type Props = {
  profile: CommunityUserProfile;
};

export default function ProfileSocialLinks({ profile }: Props) {
  const buttons = Object.entries(profile.social).map(([key, value]) => {
    return value ? (
      <SocialButton key={key} platform={key as SocialPlatform} link={value} />
    ) : null;
  });

  return <div className={styles.Links}>{buttons}</div>;
}
